import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MessageFilledSvg from "@ant-design/icons-svg/es/asn/MessageFilled";
import AntdIcon from "../components/AntdIcon";
var MessageFilled = function MessageFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MessageFilled.displayName = 'MessageFilled';
}
export default /*#__PURE__*/React.forwardRef(MessageFilled);